var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495.6 305.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8f6fc;opacity:.7}.cls-2,.cls-9{fill:#76a5b9}.cls-3{fill:#c6774b}.cls-4{fill:#fddcc6}.cls-12,.cls-5{fill:#23315b}.cls-10,.cls-13,.cls-14,.cls-15,.cls-17,.cls-18,.cls-6,.cls-7,.cls-8{fill:none}.cls-18,.cls-6,.cls-7{stroke:#fddcc6}.cls-13,.cls-18,.cls-6,.cls-9{stroke-linecap:round}.cls-13,.cls-6,.cls-9{stroke-linejoin:round}.cls-13,.cls-6{stroke-width:1.5px}.cls-10,.cls-14,.cls-15,.cls-17,.cls-18,.cls-7,.cls-8{stroke-miterlimit:10}.cls-17,.cls-18,.cls-7{stroke-width:3px}.cls-8{stroke:#c6774b;stroke-width:2px}.cls-15,.cls-9{stroke:#76a5b9}.cls-9{stroke-width:1.78px}.cls-10{stroke:#ffce00;stroke-width:1.3px}.cls-11{fill:#ffce00}.cls-12{opacity:.2}.cls-13,.cls-14{stroke:#23315b}.cls-15{stroke-width:2.5px}.cls-16{fill:#588089}.cls-17{stroke:#ffedb2}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.54 212.55c.33-2.71.52-5.43.61-8.16.16-5.2.38-10.43 0-15.63-.58-8.64-2.67-17-4.82-25.38a116.81 116.81 0 0 0-6.33-18.15c-12.44-28.23-32.35-52.06-55.14-72.54A282.28 282.28 0 0 0 364.65 47a315.28 315.28 0 0 0-43-24.25 281.32 281.32 0 0 0-46.27-16A204.41 204.41 0 0 0 234.64.43c-16.15-.83-32.37-.64-48.33 2.19a192.52 192.52 0 0 0-41.61 12.05 198.26 198.26 0 0 0-70.11 50.11 176.37 176.37 0 0 0-24.29 35.45 156.39 156.39 0 0 0-14.2 40.26 121.41 121.41 0 0 0-2.37 17.29 23.31 23.31 0 0 0-.32 6.85 54.29 54.29 0 0 0-1.4 7.45c-.63 6-.92 12.34.36 18.28a62.89 62.89 0 0 0 3.19 11.49A74.62 74.62 0 0 0 41 211.92a54.48 54.48 0 0 0 10.6 11.68 29.9 29.9 0 0 0 3.31 2.5 107.63 107.63 0 0 0 10 6.06c4.81 2.47 10.19 3.85 15.36 5.28a43.83 43.83 0 0 0 9 1.51 97.78 97.78 0 0 0 17.78-.18c18.31-2.21 35.35-9.92 53-14.79a159.33 159.33 0 0 1 33.48-4.07 111.89 111.89 0 0 1 20.75 3.16A111.08 111.08 0 0 1 233.4 232c23 15.14 41.75 35.87 65.1 50.53 8.2 5.15 16.38 10.2 25.32 14a124.26 124.26 0 0 0 27.18 8.01 99.25 99.25 0 0 0 14.31 1.08 85 85 0 0 0 14.09-.52 111.82 111.82 0 0 0 15.6-3.61 57.67 57.67 0 0 0 7.41-2.72 93.79 93.79 0 0 0 19.81-11.68A139.75 139.75 0 0 0 433.3 277a75.28 75.28 0 0 0 5.5-6.07 123.11 123.11 0 0 0 12.68-19.57 90.74 90.74 0 0 0 6.38-15.36c2.42-7.71 4.7-15.4 5.68-23.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84 175.62l-1.79-2.77c-3.64-5.63-8.86-8.77-14.3-8.58L26 165.68c-9.24.89-26.3 11.86-26 24.8.6 23.33-2.18 57.75 11.14 65.84 12.55 7.62 42.86 9.61 67.86-7.21 9.42-6.33 6.59-7.48 11.09-19.27 5.01-13.15-4.39-51.55-6.09-54.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.27 172.81L47.41 127.35 33.98 127.35 33.98 175.29 60.27 172.81z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 47.12,
    cy: 174.26,
    rx: 13.8,
    ry: 9.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.92 174.37a7.44 7.44 0 0 0-1.46-4.32l-12.05-42.6h-7.87l14 55.48c4.38-1.62 7.38-4.84 7.38-8.56z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 55.73,
    cy: 124.93,
    rx: 28.95,
    ry: 33.13,
    transform: "rotate(-8.72 55.773 124.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.32 110.55C75.56 98 63.36 90.23 50.67 92.18c-8.36 1.28-15.23 6.55-19.46 13.9a14.79 14.79 0 0 0-2.15 4.47c-6 18.17 1.05 28.78 1.05 28.78l3.34-15.43A16.92 16.92 0 0 1 50 110.55z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 28.96,
    cy: 128.15,
    r: 5.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 81.32,
    cy: 127.35,
    r: 5.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 55.16,
    cy: 128.15,
    r: 2.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 76.44,
    cy: 125.59,
    r: 2.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47.16 124.49a9.45 9.45 0 0 1 4.84-4.16 7.94 7.94 0 0 1 6-.17m23-1.49a9.48 9.48 0 0 0-6.23-1.42 8 8 0 0 0-5.42 2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.59 138.24L63.01 138.26 62.55 118.1 64.97 118.05 67.59 138.24z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 407.76,
    cy: 102.92,
    r: 48.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.17 36.2H379.99V232H123.17z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 124.86,
    cy: 127.55,
    r: 12.68,
    transform: "rotate(-13.32 124.868 127.563)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 121.12,
    cy: 140.72,
    r: 12.68,
    transform: "rotate(-13.32 121.12 140.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 138.35,
    cy: 118.47,
    r: 12.68,
    transform: "rotate(-13.32 138.345 118.459)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 158.36,
    cy: 122.84,
    r: 12.68,
    transform: "rotate(-13.32 158.365 122.837)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 161.22,
    cy: 137.53,
    r: 12.68,
    transform: "rotate(-13.32 161.206 137.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.73 190.73h40.88A69.25 69.25 0 0 1 230.87 260v19.65H71.13A19.65 19.65 0 0 1 51.48 260a69.25 69.25 0 0 1 69.25-69.25z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 146.36,
    cy: 159.59,
    r: 18.81,
    transform: "rotate(-11.02 146.313 159.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    transform: "rotate(-11.02 144.53 150.378)",
    d: "M125.76 140.55H163.38V160.25H125.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.58 207.63L120.45 207.63 132.6 170.62 143.98 170.62 152.58 207.63z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 136.51,
    cy: 207.63,
    rx: 16.07,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124 154.4a21.28 21.28 0 0 1 40.11-14.21"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 125.46,
    cy: 158.09,
    r: 5.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 146.14,
    cy: 150.73,
    r: 8.94,
    transform: "rotate(-54.05 146.124 150.727)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 163.42,
    cy: 146.12,
    r: 8.94,
    transform: "rotate(-54.05 163.4 146.111)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.69 162.13h73.42A10.91 10.91 0 0 1 333 173v22a24.34 24.34 0 0 1-24.34 24.34h-46.54A24.34 24.34 0 0 1 237.78 195v-22a10.91 10.91 0 0 1 10.91-10.91z",
    transform: "rotate(174.05 285.402 190.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M263.61 170.83L268.38 131.44 279.52 129.7 285.74 169.47 263.61 170.83z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 274.7,
    cy: 170.32,
    rx: 11.58,
    ry: 8.12,
    transform: "rotate(-8.88 274.727 170.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M263.27 172.2a6.22 6.22 0 0 1 .65-3.77l4.47-36.9 6.53-1-4.4 47.83c-3.86-.79-6.77-3.07-7.25-6.16z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 261.17,
    cy: 130.52,
    rx: 24.31,
    ry: 27.82,
    transform: "rotate(-.16 257.65 129.275)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 279.51,
    cy: 109.08,
    r: 5.47,
    transform: "rotate(-58.82 279.52 109.082)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 240.86,
    cy: 113.21,
    rx: 14.03,
    ry: 8.36,
    transform: "rotate(-13.32 240.912 113.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M238.07 121.9c3.16-11.12 12.26-19.18 23-19.21a23 23 0 0 1 17.95 9 12.14 12.14 0 0 1 2.37 3.43c7.36 14.29 2.86 24 2.86 24l-4.77-12.37a14.23 14.23 0 0 0-15.46-8.93z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 283.79,
    cy: 129.72,
    r: 4.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 240.25,
    cy: 135.84,
    r: 4.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.92 143.44L254.73 142.87 252.49 126.08 250.48 126.35 250.92 143.44z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 262.05,
    cy: 133.11,
    r: 2.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 244.07,
    cy: 133.75,
    r: 2.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M268.21 129a7.85 7.85 0 0 0-4.56-2.82 6.74 6.74 0 0 0-5 .63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M235.82 189.13L337.51 173.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M243.97 199.91L323.61 189.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M243.11 210.02L322.75 199.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M306.62 173.7h128.73a9.44 9.44 0 0 1 9.44 9.44v45.2a46.94 46.94 0 0 1-46.94 46.94h-53.73a46.94 46.94 0 0 1-46.94-46.94v-45.2a9.44 9.44 0 0 1 9.44-9.44z",
    transform: "rotate(-173.29 370.976 224.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 371.94,
    cy: 128.62,
    r: 20.49,
    transform: "rotate(-83.29 371.926 128.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.59 150c-.71 0-1.42-.06-2.14-.15a21.35 21.35 0 0 1-18.69-23.68 21.33 21.33 0 1 1 42.37 5A21.38 21.38 0 0 1 371.59 150zm-19.17-23.63a19.65 19.65 0 1 0 7.34-13.13 19.69 19.69 0 0 0-7.34 13.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    transform: "rotate(-173.29 373.13 118.497)",
    d: "M352.64 107.75H393.63V129.22H352.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M392.22 132.38h-.08l-40.71-4.79a.84.84 0 0 1-.74-.93l2.51-21.32a.87.87 0 0 1 .94-.74l40.7 4.79a.86.86 0 0 1 .74.94l-2.51 21.32a.85.85 0 0 1-.85.74zM352.46 126l39 4.6 2.35-19.6-39-4.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.14 183.86L392.91 187.95 384.14 144.45 372.16 144.91 358.14 183.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.78 121.15A23.18 23.18 0 1 0 351 109"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 394.53,
    cy: 125.28,
    r: 5.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M394.42 131.84h-.66a6.6 6.6 0 1 1 .66 0zm.18-11.44a4.88 4.88 0 0 0-4.92 4.31 4.88 4.88 0 0 0 1 3.6 4.82 4.82 0 0 0 3.26 1.82 4.88 4.88 0 0 0 1.14-9.7 4.19 4.19 0 0 0-.48-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M386.85 100.93s18-40.6 55.41-1.36 53.34 84.29 53.34 84.29l-44.67-1.1s-16.6-53.12-43.38-70.49-26.55 18.9-20.7-11.34z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 373.79,
    cy: 126.37,
    r: 2.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 355.17,
    cy: 123.41,
    r: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 196.51,
    y: 205.23,
    width: 112.88,
    height: 79.52,
    rx: 2.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 167.22,
    y: 269.21,
    width: 127.41,
    height: 23.54,
    rx: 11.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M255.06 243.44l-3-.36a.49.49 0 0 0-.54.43l-.15 1.3a.49.49 0 0 0 .43.54l3 .36a.49.49 0 0 0 .54-.43l.15-1.3a.48.48 0 0 0-.43-.54zm5.72-6.18l-.52-1.41.35-.15c.1 0 .19-.09.08-.37s-.27-.23-.27-.23l-.44.17a1.26 1.26 0 0 0-.94-.7l-.75-.09a.45.45 0 0 0-.36.06.49.49 0 0 1-.39.11l-5.1-.6c-.05 0-.05 0-.08-.06a.74.74 0 0 0-.81 0l-.68.63a.94.94 0 0 1-.52.24.22.22 0 0 0 .05-.21l-.06-.16.14-.27h.1v-.14l-.18.06c-.12 0-.12.1-.12.1a.26.26 0 0 1-.21.17s-.22-.59-.26-.67-.08-.3-1.12.11-.83.63-.83.63l.26.68-.11.07.18.51-.29.14c-.23.12-.47.23-.52.61l-1.65 14c-.13 1.05.12 1.57 1.3 1.71l10.73 1.26c.7.08 1.4-.2 1.54-1.41l1.64-13.87c.06-.7-.09-.73-.16-.92zm-7.57-2.07l3.57.42a.55.55 0 1 1-.13 1.1l-3.57-.42a.55.55 0 1 1 .13-1.1zm3.23 11.57s.95 2.24 1.15 2.74c.25.68-.23.9-.23.9a.69.69 0 0 1-.88-.35c-.2-.49-.86-2.06-1.1-2.55s-.45-.85-1-.91l-1.21-.15h-.09l-1.22-.14c-.52-.06-.7.12-1.16.66s-1.36 1.79-1.68 2.22a.69.69 0 0 1-.94.14s-.42-.33 0-.92 1.76-2.4 1.76-2.4a1.9 1.9 0 0 0 .4-.81l.13-1.07v-.2l.13-1.07a2 2 0 0 0-.21-.88s-1-2.22-1.15-2.73c-.26-.67.22-.89.22-.89a.7.7 0 0 1 .89.35c.2.49.87 2.06 1.12 2.54.31.63.45.85 1 .91l1.22.15h.08l1.22.14c.51.06.7-.12 1.15-.66s1.36-1.79 1.67-2.22a.68.68 0 0 1 .93-.13s.42.32 0 .91-1.75 2.4-1.75 2.4a2 2 0 0 0-.4.81l-.12 1.06v.2l-.12 1.07a1.85 1.85 0 0 0 .19.88z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 375.53,
    cy: 185.9,
    rx: 2.64,
    ry: 17.38,
    transform: "rotate(-83.29 375.508 185.906)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 70.72,
    cy: 264.82,
    r: 38.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M230.9 70.8c-6.77 0-6.77-7.37-13.53-7.37s-6.77 7.37-13.53 7.37-6.77-7.37-13.54-7.37-6.76 7.37-13.53 7.37-6.77-7.37-13.54-7.37-6.77 7.37-13.54 7.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M339.33 285s24.79-26.13 37.15-41.8c7.78-9.88 21.7-35 21.7-35s4.12 4.9 15.77 7.75a16.21 16.21 0 0 1 12.69 13.39s3.95 27.87-24.63 45.86-62.37 18-62.37 18-4.26 4.91-7 5.41c-4 .75-8.32-.67-7.08-4.47 1.16-3.56 6.73-3.08 6.41-5.37s-2.72-1.48-2.06-2.66c1.3-2.31 9.42-1.11 9.42-1.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M381.14 123.83a9 9 0 0 0-4.39-4.18 7.57 7.57 0 0 0-5.7-.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M365.62 135.1L362.83 135.11 362.56 122.86 364.03 122.83 365.62 135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M230.84 95.57c-7.65 0-7.65-7.38-15.31-7.38s-7.65 7.38-15.31 7.38-7.65-7.38-15.31-7.38-7.65 7.38-15.3 7.38-7.66-7.38-15.32-7.38-7.65 7.38-15.31 7.38-7.66-7.38-15.31-7.38-7.66 7.38-15.32 7.38"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.95601dd2836379b9abf60f9ec63c8eed.svg";
export { ForwardRef as ReactComponent };